import React, {Component} from 'react';
import Utils from '../../utils';

class LocationPanel extends Component{
    
    constructor(){
        super()
        this.state = {
            isInview : true
        }
    }
    onClose(){
        this.setState({ isInview : false } , function(){
            this.props.closeLocation(this.props.currentLocation);
        })
         
    }

    getCurrentLocation(){
        let filteredByRegion =  Utils.filterDataByProp(this.props.apiData.location_data , 'region',  this.props.currentRegion);
        let location =  Utils.filterDataByProp(filteredByRegion , 'location',  this.props.currentLocation);
        
        return location[0];
    }

    render(){
        let loc = this.getCurrentLocation();

         if (!loc) {
            return (<div></div>);
        } else {

            let cssClasses = ' location-component-wrapper ' + (this.state.isInview ? ' inview ' : ' ');
            let primeLandValues = (<div></div>);
            let rentStats = (<div></div>);
             let percentageCssClass = String(loc.y_on_y_change) === '0' ? 'stat-percentage zero' : ' stat-percentage ';

             const has20Value = String(loc._20k_sq_ft) !== '' && String(loc._20k_sq_ft) !== '0';
             const has50Value = String(loc._50k_sq_ft) !== '' && String(loc._50k_sq_ft) !== '0';
             const has100Value = String(loc._100k_sq_ft) !== '' && String(loc._100k_sq_ft) !== '0';


            if (String(loc.prime_land_values) !== '') {
                primeLandValues = <div className="columns">
                    <p className="stat-title">PRIME LAND VALUE</p>
                    <p className="stat stat-spec-dev">
                        <span className="stat-val">£{loc.prime_land_values}</span><br />
                        <span className="stat-label">per acre</span>
                    </p>
                </div>
            }

             if (has20Value || has50Value || has100Value) {
                 
               rentStats = <div className="columns">
                    <p className="stat-title setheight">Rents (per sq ft)</p>
                        {has20Value &&
                           <p className="stat stat-prime">
                               <p className={percentageCssClass}><span>{Math.round(Number(loc._20k_y_on_y_change) * 100) / 100}%<br /><small>Y-on-Y</small></span></p>
                               <span className="stat-val"><span className="currency">£</span>{loc._20k_sq_ft}</span>
                               <span className="stat-label">20k sq ft</span>
                           </p>
                       }
                       {has50Value &&
                           <p className="stat stat-secondary">
                               <p className={percentageCssClass}><span>{Math.round(Number(loc._50k_y_on_y_change) * 100) / 100}%<br /><small>Y-on-Y</small></span></p>
                               <span className="stat-val"><span className="currency">£</span>{parseFloat((loc._50k_sq_ft)).toFixed(2)}</span>
                               <span className="stat-label">50k sq ft</span>
                           </p>
                       }
                       {has100Value &&
                           <p className="stat stat-third">
                               <p className={percentageCssClass}><span>{Math.round(Number(loc._100k_y_on_y_change) * 100) / 100}%<br /><small>Y-on-Y</small></span></p>
                               <span className="stat-val"><span className="currency">£</span>{parseFloat((loc._100k_sq_ft)).toFixed(2)}</span>
                               <span className="stat-label">100k sq ft</span>
                           </p>
                       }
                </div>
            }

            return(
            <div className={cssClasses}>
                <div className="location-component">
                    <div className="location-heading hide-only-mobile">
                        <span className="circle">{this.props.currentLocationIndex}</span><h4 className="location-title">{this.props.currentLocationLabel}</h4>
                    </div>
                    <div className="location-stats row">
                        {rentStats}
                        {primeLandValues}
                    </div>
                    <div className="location-description">
                        <p className="copy-block truncate">{loc.location_comment}</p>
                    </div>
                </div> 
            </div> 
            )
        }
    }
}

export default LocationPanel;


// WEBPACK FOOTER //
// ./src/js/components/layout/LocationPanel.js